import Immutable from "immutable";
import { floatToMoney } from "lib/money";

import * as studentLinked from "lib/appserver/entityHeaders/studentLinked";

const PaymentHistoryItem = new Immutable.Record({
  description: undefined,
  installmentNumber: undefined,
  paidAmount: undefined,
  paidDate: undefined,
  refundedAmount: undefined,
  paymentMethod: undefined,
  ...studentLinked.defaultProperties
}, "Payment History Item");

function buildPaymentHistoryItemFromAppserver(rawHistoryItem) {
  const rawPaymentHistoryItem = rawHistoryItem.payload;
  // TODO: fix this on the server end (hopefully?)
  rawHistoryItem.student_fk = rawPaymentHistoryItem.student_fk;
  return PaymentHistoryItem({
    description: rawPaymentHistoryItem.payment_description,
    installmentNumber: rawPaymentHistoryItem.installment_number,
    paidAmount: floatToMoney(rawPaymentHistoryItem.paid_amount),
    paidDate: rawPaymentHistoryItem.paid_date,
    refundedAmount: floatToMoney(rawPaymentHistoryItem.refunded_amount),
    paymentMethod: rawPaymentHistoryItem.payment_method,
    ...studentLinked.appserverAdapter(rawHistoryItem)
  })
}

PaymentHistoryItem.fromAppserver = buildPaymentHistoryItemFromAppserver;
export default PaymentHistoryItem;



// WEBPACK FOOTER //
// ./src/state/school_money/entities/PaymentHistoryItem.js